import { makeStyles, Theme, createStyles } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        sectionTitle: {
            ...commonStyles.sectionTitle,
            marginBottom: 20,
            marginTop: 20,
        },
        chipContainer: {
            maxWidth: '33%',
            width: '100%',
        },
        chip: {
            maxWidth: '100%',
            width: '100%',
            '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
            },
        },
        chipGrid: {
            maxWidth: '100%',
            overflow: 'hidden',
        },
        masterChangeContainer: {
            padding: '12px 16px',
            borderRadius: 5,
            backgroundColor: theme.palette.grey[100],
            border: `1px solid ${theme.palette.grey[300]}`,
        },
        masterChangeText: {
            color: theme.palette.text.secondary,
            fontSize: 14,
        },
        masterChangeActions: {
            marginTop: 14,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
        },
    })
);
